// DiningVenue.jsx
import React, { useEffect, useState } from "react";
import "./ServicePreview.scss";
import { callAPI } from "../../../axios";
import { CircularProgress } from "@mui/material";

const ServicePreview = (props) => {
  const { previewListRowData, closePreview } = props;
  const [loader, setLoader] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState("");
  const [previewData, setPreviewData] = useState([]);

  const [categoryDetails, setCategoryDetails] = useState([]);

  useEffect(() => {
    setLoader(true);
    callAPI(`/hotel-specials/categories/${previewListRowData?.id}`, "GET")
      .then((response) => {
        setPreviewData(response);
        if(response?.length){
            setSelectedVenue(response[0]?.id)
        }
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  }, [previewListRowData]);

  useEffect(() => {
    const temp = previewData?.filter((data) => data?.id === selectedVenue);
    if (temp?.length) {
      setCategoryDetails(temp[0]);
    }
  }, [selectedVenue]);

  //   const venues = [
  //     { name: 'Planters Club', active: false },
  //     { name: 'Bayleaf', active: true },
  //     { name: 'Teapot', active: false },
  //     { name: 'Vintage Bar', active: false }
  //   ];

  //   const venueDetails = {
  //     'Bayleaf': {
  //       title: 'Bayleaf',
  //       description: 'Bay Leaf is a day eatery that is an open-air joint surrounded by bay leaf trees and overlooks the stunning tea gardens. It is a quaint restaurant in Siliguri.',
  //       openingHours: {
  //         lunch: '12:30 pm to 02:40 pm',
  //         dinner: '07:00 pm to 10:30 pm'
  //       }
  //     },
  //     'Planters Club': {
  //       title: 'Planters Club',
  //       description: 'An exclusive club restaurant offering premium dining experience with colonial charm and modern amenities.',
  //       openingHours: {
  //         lunch: '12:00 pm to 03:00 pm',
  //         dinner: '07:30 pm to 11:00 pm'
  //       }
  //     },
  //     'Teapot': {
  //       title: 'Teapot',
  //       description: 'A cozy tea house serving the finest selection of teas along with light snacks and pastries.',
  //       openingHours: {
  //         lunch: '11:00 am to 04:00 pm',
  //         dinner: '06:00 pm to 09:30 pm'
  //       }
  //     },
  //     'Vintage Bar': {
  //       title: 'Vintage Bar',
  //       description: 'A sophisticated bar with vintage ambiance, serving premium spirits and cocktails.',
  //       openingHours: {
  //         lunch: '01:00 pm to 04:00 pm',
  //         dinner: '07:00 pm to 12:00 am'
  //       }
  //     }
  //   };

  const handleVenueSelect = (venueName) => {
    setSelectedVenue(venueName);
  };

  return (
    <div className="dining-page">
      {/* STB Preview Header */}
      <div className="stb-header">
        <button className="back-arrow" onClick={closePreview}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h1 className="stb-title">Hotel Service Category Preview on STB</h1>
        <div className="header-spacer"></div>
      </div>
    <div className="dining-container">
      {loader && (
        <div className="circular-progress">
          <CircularProgress />
        </div>
      )}
      <div className="background-image">
        <img
          src={categoryDetails?.bgImageUrl}
          alt="Restaurant Interior"
          className="bg-img"
        />
      </div>

      {/* Centered Page Title */}
      <div className="page-header">
        <h1 className="page-title">{previewListRowData?.menuName}</h1>
      </div>

      <div className="venue-sidebar">
        {previewData?.map((venue) => (
          <button
            key={venue.categoryName}
            className={`venue-button ${
              venue?.id === selectedVenue ? "active" : ""
            }`}
            onClick={() => handleVenueSelect(venue?.id)}
          >
            {venue.categoryName}
          </button>
        ))}
      </div>

      {categoryDetails?.featureSet?.length ? <div className="venue-details">
        <h2 className="venue-title">{categoryDetails?.categoryName}</h2>
        <p className="venue-description">{categoryDetails?.description}</p>

        <div className="opening-hours">
          <h3 className="hours-title">{categoryDetails?.featureTitle}</h3>
          {categoryDetails?.featureSet?.map((feature, index) => {
            return (
              <div className="hours-item" key={index}>
                <span className="hours-label">{feature?.featureKey}</span>
                <span className="hours-colon">:</span>
                <span className="hours-time">{feature?.featureValue}</span>
              </div>
            );
          })}
        </div>

        {categoryDetails?.type!="NO_CONTENT"?<button className="view-gallery-btn">{categoryDetails?.type=="UPLOAD_PICTURE"?"View Gallery":categoryDetails?.type=="WEB_LINK"?"View Webpage":"Watch Video"}</button>:<></>}
      </div>:<></>}
    </div>
    </div>
  );
};

export default ServicePreview;
